import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import AuthService from '../modules/auth/redux/AuthService'
import {MainPageWrapper} from '../pages/MainPageWrapper'

export function PrivateRoutes() {
  const TahsilatWrapper = lazy(() => import('../pages/Tahsilat/TahsilatWrapper'))


  const user = AuthService.GetCurrentUser()

  const isAdmin = user.userData?.roles?.some((element: string) => element === "Anavezne Admin")
  const link = isAdmin ? '/ana-vezne' : "/tahsilatListesi"
  

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {isAdmin ? (
        <>
          {/* <Route path='/ana-vezne' component={MainPageWrapper} /> */}
          <Route path='/tahsilatListesi' component={TahsilatWrapper} /> 
        </>
        ) : <Route path='/tahsilatListesi' component={MainPageWrapper} /> }

        <Redirect from='/auth' to={link} />
        <Redirect exact from='/' to={link} />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
